import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import { WindowBreakpoints } from '@/hooks/useWindowResponsive';

interface AppStoreSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  responsive?: WindowBreakpoints & {
    isNarrow: boolean;
    isMedium: boolean;
  };
}

export function AppStoreSearchBar({ value, onChange, responsive }: AppStoreSearchBarProps) {
  return (
    <div className={cn(
      "relative",
      responsive?.isNarrow ? "w-full" : "max-w-lg"
    )}>
      <Search className={cn(
        "absolute left-4 top-1/2 transform -translate-y-1/2 text-zinc-500 transition-colors",
        responsive?.isNarrow ? "h-4 w-4" : "h-5 w-5"
      )} />
      <Input
        placeholder="Search apps..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn(
          "bg-gradient-to-r from-zinc-900/70 to-zinc-800/50",
          "backdrop-blur-sm border-zinc-700/50 rounded-xl",
          "focus:bg-zinc-800/60 focus:border-amber-900/50 focus:shadow-lg focus:shadow-amber-900/10",
          "transition-all duration-300",
          "text-zinc-100 placeholder:text-zinc-500 font-light",
          responsive?.isNarrow ? "pl-10 pr-4 h-10 text-sm" : "pl-12 pr-4 h-11 text-base"
        )}
      />
    </div>
  );
}
